import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import type {
  BulkUpdateSalaryComponentsVariables,
  BulkUpdateSalaryComponentsResponse,
} from '../types';

const bulkUpdateSalaryComponentsMutation = gql`
  mutation PayrollBulkUpdateSalaryComponents($input: PayrollBulkUpdateSalaryComponentsInput!) {
    payrollBulkUpdateSalaryComponents(input: $input) {
      code
      success
      message
    }
  }
`;

const bulkUpdateSalaryComponents = (variables: BulkUpdateSalaryComponentsVariables) => {
  return graphQLApi<
    { payrollBulkUpdateSalaryComponents: BulkUpdateSalaryComponentsResponse },
    BulkUpdateSalaryComponentsVariables
  >({
    query: bulkUpdateSalaryComponentsMutation,
    queryVariables: variables,
  });
};

export default bulkUpdateSalaryComponents;
